import {
	useEffect,
	useState,
} from 'react';
import {
	FormField, getFormFieldHtmlForValue,
	InputProps,
} from '..';
import './Textarea.scss';


export const Textarea = ({
	placeholderText,
	usePlaceholderAsLabel = false,
	onClear = () => {},
	onChange = () => {},
	rowValue,
	readOnly = false,
	maxLength,
	minLength,
	// max,
	// min,
	title,
	// pattern,
	// onValidation,
	hint,
	isPrivate = false,
}: InputProps): JSX.Element => {
	// const [isValid, setIsValid] = useState(false);
	const [value, setValue] = useState<string | undefined>(rowValue);
	const [error] = useState<string>();
	const [isBlurTriggered, setIsBlurTriggered] = useState<boolean>(false);

	useEffect(() => {
		setValue(rowValue);
	}, [rowValue]);

	useEffect(() => {
		onChange(value || '');
	}, [onChange, value]);

	return (
		<FormField
			placeholderText={placeholderText}
			usePlaceholderAsLabel={usePlaceholderAsLabel}
			value={value}
			setValue={v => setValue(v)}
			hint={hint}
			onClear={onClear}
			error={error}
			isBlurTriggered={isBlurTriggered}
			htmlFor={getFormFieldHtmlForValue(placeholderText)}
		>
			<textarea
				id={getFormFieldHtmlForValue(placeholderText)}
				name={getFormFieldHtmlForValue(placeholderText)}
				value={value}
				onChange={({
					target,
				}) => {
					setValue(target?.value);
				}}
				maxLength={maxLength}
				minLength={minLength}
				disabled={readOnly}
				title={title}
				onBlur={() => setIsBlurTriggered(true)}
				data-private={isPrivate}
			></textarea>
		</FormField>
	);
};